<template>
  <div class="input" :class="wrapperClasses">
    <Label
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div :class="controlClasses">
      <BaseTextarea
        :id="id"
        v-model="data"
        :count-chars="true"
        :error="error"
        :class="labelClass"
        :disabled="disabled"
        @input="$emit('input', $event)"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseTextarea from "@/components/Base/Controls/BaseTextarea";
import Label from "@/components/Base/Elements/BaseLabel";

export default {
  name: "TextareaControl",
  components: {
    BaseTextarea,
    Label
  },
  extends: BaseFormControl,
  data() {
    return {
      data: this.value
    };
  }
};
</script>
